/* Lighting Reimagined — global behaviors
   Announcement rotation (with pause control), mega menu, mobile drawer,
   brands A–Z filter, quantity steppers. No dependencies. */

(function () {
  'use strict';

  function initAnnouncementBar() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;
    var messages = bar.querySelectorAll('[data-announcement-message]');
    if (messages.length < 2) return;
    var speed = parseInt(bar.getAttribute('data-speed'), 10) || 5;
    var index = 0;
    var paused = false;
    var hovered = false;
    var timer = null;
    var toggle = bar.querySelector('[data-announcement-toggle]');
    function show(i) { messages.forEach(function (m, j) { m.hidden = j !== i; }); }
    function tick() { index = (index + 1) % messages.length; show(index); }
    function update() { clearInterval(timer); timer = null; if (!paused && !hovered) timer = setInterval(tick, speed * 1000); }
    bar.addEventListener('mouseenter', function () { hovered = true; update(); });
    bar.addEventListener('mouseleave', function () { hovered = false; update(); });
    if (toggle) {
      toggle.addEventListener('click', function () {
        paused = !paused;
        toggle.setAttribute('aria-label', paused ? toggle.getAttribute('data-label-play') : toggle.getAttribute('data-label-pause'));
        toggle.textContent = paused ? '\u25B6' : '\u275A\u275A';
        update();
      });
    }
    show(0);
    update();
  }

  function initMegaMenu() {
    var nav = document.querySelector('[data-site-nav]');
    if (!nav || nav.dataset.lrMegaInitialized === 'true') return;
    nav.dataset.lrMegaInitialized = 'true';
    var items = nav.querySelectorAll('[data-nav-item]');
    function closeAll(except) {
      items.forEach(function (item) {
        if (item !== except) {
          item.classList.remove('is-open');
          var t = item.querySelector('[data-nav-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
    }
    function resetFlyouts(item) {
      item.querySelectorAll('[data-flyout-trigger]').forEach(function (e) {
        e.classList.remove('is-active');
        e.setAttribute('aria-expanded', 'false');
      });
      item.querySelectorAll('[data-flyout-panel]').forEach(function (p) { p.classList.remove('is-active'); });
    }
    items.forEach(function (item) {
      var toggleBtn = item.querySelector('[data-nav-toggle]');
      if (!toggleBtn) return;
      item.addEventListener('mouseenter', function () { closeAll(item); item.classList.add('is-open'); toggleBtn.setAttribute('aria-expanded', 'true'); });
      item.addEventListener('mouseleave', function () { item.classList.remove('is-open'); toggleBtn.setAttribute('aria-expanded', 'false'); resetFlyouts(item); });
      toggleBtn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) closeAll(item);
      });
      toggleBtn.addEventListener('focus', function () { closeAll(item); item.classList.add('is-open'); toggleBtn.setAttribute('aria-expanded', 'true'); });
      item.querySelectorAll('[data-flyout-trigger]').forEach(function (entry) {
        var targetId = entry.getAttribute('data-flyout-trigger');
        function activate() {
          item.querySelectorAll('[data-flyout-trigger]').forEach(function (e) {
            e.classList.toggle('is-active', e === entry);
            e.setAttribute('aria-expanded', e === entry ? 'true' : 'false');
          });
          item.querySelectorAll('[data-flyout-panel]').forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-flyout-panel') === targetId);
          });
        }
        entry.addEventListener('mouseenter', activate);
        entry.addEventListener('focus', activate);
        entry.addEventListener('click', activate);
      });
      item.querySelectorAll('[data-flyout-leave]').forEach(function (el) { el.addEventListener('mouseenter', function () { resetFlyouts(item); }); });
    });
    nav.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(null); if (document.activeElement) document.activeElement.blur(); } });
    nav.addEventListener('focusout', function (e) { if (!nav.contains(e.relatedTarget)) closeAll(null); });
    document.addEventListener('click', function (e) { if (!nav.contains(e.target)) closeAll(null); });
  }

  function initMobileDrawer() {
    var openBtn = document.querySelector('[data-mobile-open]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    if (!openBtn || !drawer || drawer.dataset.lrMobileInitialized === 'true') return;
    drawer.dataset.lrMobileInitialized = 'true';

    function panelFor(toggle) {
      var id = toggle.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    }

    function installLinkStyles() {
      if (document.getElementById('lr-mobile-parent-link-styles')) return;
      var style = document.createElement('style');
      style.id = 'lr-mobile-parent-link-styles';
      style.textContent =
        '.mobile-nav__link-row{display:flex;align-items:stretch;width:100%;}' +
        '.mobile-nav__parent-link{display:flex;flex:1 1 auto;align-items:center;min-width:0;padding:12px 16px;font-family:var(--font-sans);font-size:14px;font-weight:700;letter-spacing:.02em;color:var(--c-nav-fg);text-decoration:none;}' +
        '.mobile-nav__parent-link--sale{color:var(--c-sale);}' +
        '.mobile-nav__sub .mobile-nav__link-row .mobile-nav__parent-link{padding:10px 32px;font-size:14px;font-weight:600;}' +
        '.mobile-nav__caret-toggle{display:flex!important;align-items:center!important;justify-content:center!important;width:52px!important;min-width:52px!important;flex:0 0 52px!important;padding:0!important;}' +
        '.mobile-nav__caret-toggle .caret{margin-left:0!important;width:16px!important;height:16px!important;min-width:16px!important;flex:0 0 16px!important;}';
      document.head.appendChild(style);
    }

    function makeParentLabelsLinks() {
      installLinkStyles();
      drawer.querySelectorAll('[data-accordion-toggle]').forEach(function (toggle) {
        if (toggle.dataset.lrParentLinkSplit === 'true') return;
        var panel = panelFor(toggle);
        var destination = panel && panel.querySelector(':scope > a[href]');
        if (!destination) return;

        var label = '';
        Array.prototype.forEach.call(toggle.childNodes, function (node) {
          if (node.nodeType === 3) label += node.textContent;
        });
        label = label.trim();
        if (!label) return;

        var row = document.createElement('div');
        row.className = 'mobile-nav__link-row';
        var link = document.createElement('a');
        link.className = 'mobile-nav__parent-link';
        if (toggle.classList.contains('mobile-nav__toggle--sale')) link.classList.add('mobile-nav__parent-link--sale');
        link.href = destination.href;
        link.textContent = label;

        toggle.parentNode.insertBefore(row, toggle);
        row.appendChild(link);
        row.appendChild(toggle);

        Array.prototype.slice.call(toggle.childNodes).forEach(function (node) {
          if (node.nodeType === 3) toggle.removeChild(node);
        });
        toggle.classList.add('mobile-nav__caret-toggle');
        toggle.setAttribute('aria-label', 'Toggle ' + label + ' submenu');
        toggle.dataset.lrParentLinkSplit = 'true';
      });
    }

    function closeAllSubmenus() {
      drawer.querySelectorAll('[data-accordion-toggle]').forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        var panel = panelFor(toggle);
        if (panel) panel.classList.remove('is-open');
      });
    }

    function setOpen(open, restoreFocus) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('lr-mobile-menu-open', open);
      document.body.classList.toggle('lr-mobile-menu-open', open);
      if (open) {
        var top = drawer.getBoundingClientRect().top;
        var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        drawer.style.maxHeight = Math.max(220, viewportHeight - top) + 'px';
      } else {
        drawer.style.maxHeight = '';
        closeAllSubmenus();
        if (restoreFocus && document.contains(openBtn)) openBtn.focus();
      }
    }

    makeParentLabelsLinks();
    drawer.setAttribute('aria-hidden', 'true');

    openBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(!drawer.classList.contains('is-open'), false);
    }, true);

    drawer.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-accordion-toggle]');
      if (toggle && drawer.contains(toggle)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        var panel = panelFor(toggle);
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) panel.classList.toggle('is-open', !expanded);
        return;
      }
      if (event.target.closest('a[href]')) setOpen(false, false);
    }, true);

    document.addEventListener('click', function (event) {
      if (drawer.classList.contains('is-open') && !drawer.contains(event.target) && !openBtn.contains(event.target)) setOpen(false, false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false, true);
    });
    function handleViewportChange() {
      if (window.innerWidth >= 990 && drawer.classList.contains('is-open')) { setOpen(false, false); return; }
      if (drawer.classList.contains('is-open')) {
        var top = drawer.getBoundingClientRect().top;
        var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        drawer.style.maxHeight = Math.max(220, viewportHeight - top) + 'px';
      }
    }
    window.addEventListener('resize', handleViewportChange);
    window.addEventListener('orientationchange', handleViewportChange);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', handleViewportChange);
  }

  function initBrandFilter() {
    var root = document.querySelector('[data-brand-filter]');
    if (!root) return;
    var buttons = root.querySelectorAll('[data-letter]');
    var cells = document.querySelectorAll('[data-brand-cell]');
    var count = document.querySelector('[data-brand-count]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var letter = btn.getAttribute('data-letter');
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        var visible = 0;
        cells.forEach(function (cell) {
          var match = letter === 'all' || cell.getAttribute('data-initial') === letter;
          cell.classList.toggle('hidden', !match);
          if (match) visible++;
        });
        if (count) count.textContent = visible + (visible === 1 ? ' brand' : ' brands') + (letter === 'all' ? '' : ' starting with "' + letter.toUpperCase() + '"');
      });
    });
  }

  function initQuantitySteppers() {
    if (document.documentElement.dataset.lrQtyInitialized === 'true') return;
    document.documentElement.dataset.lrQtyInitialized = 'true';
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      var wrap = btn.closest('.qty');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
      var min = parseInt(input.min || '1', 10);
      var next = Math.max(min, (parseInt(input.value, 10) || min) + delta);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function initGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery || gallery.dataset.lrGalleryInitialized === 'true') return;
    gallery.dataset.lrGalleryInitialized = 'true';
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (main) {
          main.src = thumb.getAttribute('data-src');
          if (thumb.getAttribute('data-srcset')) main.srcset = thumb.getAttribute('data-srcset');
          main.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : main.alt;
        }
      });
    });
  }

  function initAll() {
    initMobileDrawer();
    initAnnouncementBar();
    initMegaMenu();
    initBrandFilter();
    initQuantitySteppers();
    initGallery();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();

  document.addEventListener('shopify:section:load', function () {
    var drawer = document.querySelector('[data-mobile-drawer]');
    if (drawer) delete drawer.dataset.lrMobileInitialized;
    var nav = document.querySelector('[data-site-nav]');
    if (nav) delete nav.dataset.lrMegaInitialized;
    initMobileDrawer();
    initMegaMenu();
  });
})();
